import React, { ComponentProps } from "react";
import { Heading, TextMuted } from "@/components/elements/Typography";
import { UpgradeNowButton } from "@/components/modules/UpgradeNowButton";
import { formatPlanName } from "@/features/billing";
import cn from "@/helpers/classNames";
import { useWeldMinimumPlanForFeature } from "@/features/subscription";

export function AuthorizationLinkTeaser(props: ComponentProps<"div">) {
  const { minimumPlanName } = useWeldMinimumPlanForFeature(
    "externalAuthorizationEnabled",
  );

  return (
    <div {...props} className={cn("flex flex-col gap-4", props.className)}>
      <Heading className="text-center text-xl">
        Let Others Authorize on Your Behalf
      </Heading>
      <TextMuted className="text-pretty text-sm leading-snug">
        Need someone else to authorize a connector? Authorization Links let you
        generate a secure URL that someone else can use to grant access — ideal
        when you manage data for clients or don’t have direct access to the
        source.
      </TextMuted>
      <div className="flex w-full flex-col gap-4 text-center">
        <span>
          Authorization Links are available on the{" "}
          <strong>{formatPlanName(minimumPlanName)}</strong> plan.
        </span>
        <div>
          <UpgradeNowButton source="feature guard - audit logs" />
        </div>
      </div>
    </div>
  );
}
